import React from 'react';
import { Link, useStaticQuery, graphql } from 'gatsby';

import Layout from '../components/Layout';
import SideBar from '../components/SideBar';

const IndexPage = ({data}) => {
  console.log('GOT DATA', data);
  return (
  <Layout>
    <SideBar sections={[{id: 'home', name: 'Home', icon: 'fa-home'}]} />
    <div id="wrapper">
      <div id="main">
        <section>
          <div className="container">
            <section>
              <div
                className="blog-post-content"
                dangerouslySetInnerHTML={{ __html: data.markdownRemark.html }}
              />
            </section>
          </div>
        </section>
      </div>
    </div>
  </Layout>
  )
};



export const pageQuery = graphql`
  query($slug: String) {
    markdownRemark(frontmatter: { slug: { eq: $slug } }) {
      html
      frontmatter {
        slug
        title
      }
    }
  }
`
export default IndexPage;

